import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_ACCESS} from '../../constants';

export default {
  id: 'ROLE',
  title: 'Qual è il mio ruolo?',
  description: '',
  categories: [CONTENT_CATEGORY_ACCESS],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Per conoscere il tuo ruolo, vai nella scheda «Impostazioni» e poi «Utenti».'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_ROLE/IT_ROLE_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Diversi ruoli utente sono disponibili con Onceforall.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Ecco la lista dei diversi ruoli:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- Account manager: è l\'amministratore del conto. Aggiorna i documenti, gestisce le relazioni aziendali e gestisce gli utenti relativi all\'impresa'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- Chi invita: Gestisce principalmente le relazioni dell\'azienda (clienti/fornitori)'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- Chi consulta: Può semplicemente consultare i documenti dei fornitori. Può anche consultare il fascicolo della sua impresa'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- Esploratore: Può consultare e invitare solo i suoi fornitori'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'E per le autorizzazioni:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- E-signature: permesso di firmare elettronicamente i documenti'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- Gestione delle operazioni: permesso di gestire le operazioni'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Ogni utente di un\' azienda può consultare il proprio ruolo, le proprie autorizzazioni e quelle degl\'altri.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_ROLE/IT_ROLE_2.png`
  }]
};
